export const ADMIN_PERMISSIONS = {
    BTN_SAVE_PERMISSIONS: "save-permissions",
};
